import { useState, useEffect } from "react";
import { AxiosError } from "axios";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Table from "../../../core/common/dataTable/index";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "sonner";
// pour restreaindre l'accès à ce composant
import withPermission from "../../../core/common/autorisations/withPermission";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import InfosAlertYearDisabled from "../../../core/common/alerts/infosAlertYearDisabled";
import FinanceMenu from "../financeMenu";
import CreateBourseRemiseModal from "./createBourseRemiseModal";
import EditBourseRemiseModal from "./editBourseRemiseModal";
import { deleteDiscount, getAllDiscounts } from "../../../api/bourse_remise";
import Avvvatars from "avvvatars-react";
import FicheDiscountModalApercu from "./FicheDiscountModalApercu";
import AnnualRapportDiscountModalApercu from "./AnnualRapportDiscountModalApercu";
import { getPaymentSettingsByYear } from "../../../api/paiement_settings";

// boutton protégée pour créer une bourse ou remise
const ProtectedBtnAddBourse = withPermission(
  (props: any) => (
    <div className="mb-2">
      <button
        onClick={() => {
          props.setShowCreate(true);
        }}
        //   to="#"
        className="btn btn-primary d-flex align-items-center"
      >
        <i className="ti ti-square-rounded-plus me-2" />
        Nouvelle Bourse & Remise
      </button>
    </div>
  ),
  [buildPermission(Resource.BOURSE_REMISE, Action.CREATE)],
  "masquer",
);

// boutton protégée pour modifier une bourse ou remise
const ProtectedBtnUpdateBourse = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => {
          props.setEditDiscount(props.record);
          props.setShowEdit(true);
        }}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier
      </Link>
    </li>
  ),
  [buildPermission(Resource.BOURSE_REMISE, Action.UPDATE)],
  "masquer",
);

// boutton protégée pour supprimer une bourse ou remise
const ProtectedBtnDeleteBourse = withPermission(
  (props: any) => (
    <li>
      <Link
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
        to="#"
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </Link>
    </li>
  ),
  [buildPermission(Resource.BOURSE_REMISE, Action.DELETE)],
  "masquer",
);

// boutton protégée pour imprimer une bourse ou remise
const ProtectedBtnPrintBourse = withPermission(
  (props: any) => (
    <li>
      <Link
        onClick={() => {
          props.setShowFicheDiscount(true);
          props.setEditDiscount(props.record);
        }}
        className="dropdown-item rounded-1"
        to="#"
      >
        <i className="ti ti-printer me-2" />
        Imprimer
      </Link>
    </li>
  ),
  [buildPermission(Resource.BOURSE_REMISE, Action.READ)],
  "masquer",
);

// boutton exporter les rapport de Bourse / Remise
const ProtectedExportRapport = withPermission(
  (props: any) => (
    <div className="dropdown me-2 mb-2">
      <Link
        to="#"
        className="dropdown-toggle btn btn-light fw-medium d-inline-flex align-items-center"
        data-bs-toggle="dropdown"
      >
        <i className="ti ti-file-export me-2" />
        Exporter
      </Link>
      <ul className="dropdown-menu  dropdown-menu-end p-3">
        <li>
          <button
            className="dropdown-item rounded-1"
            onClick={() => {
              props.setReportType("Bourses");
              props.setShowAnnualRapportDiscount(true);
            }}
          >
            <i className="ti ti-upload me-1" />
            Rapport Bourses
          </button>
        </li>
        <li>
          <button
            className="dropdown-item rounded-1"
            onClick={() => {
              props.setReportType("Reductions");
              props.setShowAnnualRapportDiscount(true);
            }}
          >
            <i className="ti ti-upload me-1" />
            Rapport Remises
          </button>
        </li>
      </ul>
    </div>
  ),
  [buildPermission(Resource.BOURSE_REMISE, Action.READ)],
  "masquer",
);

const BourseAndRemise = () => {
  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const [allDiscounts, setAllDiscounts] = useState([]);
  const [editDiscount, setEditDiscount] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [refreshKey, setRefreshKey] = useState(0);

  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [showFicheDiscount, setShowFicheDiscount] = useState<boolean>(false);
  const [showAnnualRapportDiscount, setShowAnnualRapportDiscount] =
    useState<boolean>(false);
  const [reportType, setReportType] = useState<"Bourses" | "Reductions" | null>(
    null,
  );

  const [paymentSettings, setPaymentSettings] = useState<any>();
  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  // Les colonnes de notre tableau
  const columns = [
    {
      title: "Etudidant",
      dataIndex: "studentName",
      render: (text: string, record: any) => {
        return (
          <div className="d-flex align-items-center">
            <Link
              to={`/student-detail/${record.id}`}
              className="avatar avatar-md"
            >
              <Avvvatars
                value={`${record.firstname?.charAt(0) || ""}${
                  record.lastname?.charAt(0) || ""
                }`}
                style="character" // ou "character"
              />
            </Link>
            <div className="ms-2">
              <p className="text-dark mb-0">
                <Link
                  to="#"
                  // to={`/student-detail/${record.id}`}
                >{`${record.firstname} ${record.lastname}`}</Link>
              </p>
              <span className="fs-12">
                {record.matricule} | {record?.level?.abbreviation} -{" "}
                {record?.class?.abbreviation}
              </span>
            </div>
          </div>
        );
      },
      sorter: (a: any, b: any) =>
        a?.studentName?.length - b?.studentName?.length,
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text: string) => <span className="fw-semibold">{text}</span>,
      sorter: (a: any, b: any) => a?.type?.length - b?.type?.length,
    },
    {
      title: "Montant",
      dataIndex: "discount_amount",
      render: (text: number) => (
        <span className="text-primary fw-semibold">
          {text?.toLocaleString("fr-FR")} {paymentSettings?.currency}
        </span>
      ),
      sorter: (a: any, b: any) => a?.discount_amount - b?.discount_amount,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text: string) => <span className="text-dark">{text}</span>,
      sorter: (a: any, b: any) => a?.title?.length - b?.title?.length,
    },
    // {
    //   title: "Date de création",
    //   dataIndex: "createdAt",
    //   render: (date: string) => {
    //     const d = new Date(date);
    //     return d.toLocaleDateString("fr-FR", {
    //       year: "numeric",
    //       month: "long",
    //       day: "numeric",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //     });
    //   },
    //   sorter: (a: LevelTable, b: LevelTable) =>
    //     new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    // },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                {/* imprimer une bourse / remise */}
                <ProtectedBtnPrintBourse
                  record={record}
                  setShowFicheDiscount={setShowFicheDiscount}
                  setEditDiscount={setEditDiscount}
                />
                {/* modifier une bourse /remise */}
                <ProtectedBtnUpdateBourse
                  setEditDiscount={setEditDiscount}
                  record={record}
                  setShowEdit={setShowEdit}
                />

                {/* supprimer une bourse / remise*/}
                <ProtectedBtnDeleteBourse
                  showConfirmationAlert={showConfirmationAlert}
                  record={record}
                />
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  //Traitement en alert de la demande de réinitialisation de mot de passe
  const showConfirmationAlert = (discount: any) => {
    MySwal.fire({
      title: "Supprimer une Bourse / Remise ?",
      text: `Souhaitez-vous vraiment supprimer la bourse / remise ${discount.description} ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête de suppression
          await deleteDiscount(discount.discount_id);
          MySwal.fire({
            title: "Bourse / Remise supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });

          reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.response?.data?.message ||
              err.response?.data?.error ||
              "Une erreur est survenue, réessayez plus tard",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //Reload de la liste
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  // fonction pour récupérer les données des bourses
  const fetchData = async () => {
    // On attend que selectedYear soit défini
    if (!selectedYear?.id) return;

    setHasLoaded(false);
    setIsLoading(true);

    try {
      const res = await getAllDiscounts(
        selectedYear?.id,
        buildPermissionContext(Resource.BOURSE_REMISE, Action.READ),
      );
      // console.log("Bourses/Remises: ", res.data);

      let formattedDiscounts = res.data.flatMap((item: any) =>
        (item.discounts || []).map((discount: any) => ({
          ...discount,
          ...item,
          discounts: undefined,
        })),
      );
      // console.log("formattedDiscounts: ", formattedDiscounts);
      setAllDiscounts(formattedDiscounts || []);
    } catch (error: any) {
      // console.log("Erreur lors du chargement des Bourses/Remises: ",error);
      // Si erreur (Toast Error)
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false); //Les données ne sont plus en chargement
      setHasLoaded(true); //Les données ont été chargé avec succès
    }
  };

  //On recupère la liste des Levels en appelant sa fonction
  useEffect(() => {
    fetchData();
  }, [refreshKey, selectedYear]);

  useEffect(() => {
    fetchPaymentParameters();
  }, [selectedYear]);

  // fonction pour récupérer les paramêtres de paiement de l'année academique
  const fetchPaymentParameters = async () => {
    try {
      if (!selectedYear) return;
      const res = await getPaymentSettingsByYear(
        selectedYear?.id,
        buildPermissionContext(Resource.BOURSE_REMISE, Action.READ),
      );
      // console.log("Parameters: ", res.data);
      setPaymentSettings(res?.data[0]);
    } catch (error: any) {
      // console.log("Error fetching payment parameters:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <FinanceMenu />
            {/* Boutton en entête de la page */}
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <TooltipOption/> */}
              <ProtectedExportRapport
                setReportType={setReportType}
                setShowAnnualRapportDiscount={setShowAnnualRapportDiscount}
              />
              <ProtectedBtnAddBourse setShowCreate={setShowCreate} />
            </div>
          </div>
          {/* /Page Header */}
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          {/* Tableau liste du personnel administratif */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Bourses & Rémises</h4>
            </div>
            <div className="card-body p-0 py-3">
              {/* Staffs List (On affiche le tableau qui si les données son chargées même vide) */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={allDiscounts}
                  Selection={true}
                />
              )}
              {/* /Staffs List */}
            </div>
          </div>
        </div>
        {/* /Page Header */}

        {/* <EditPaymentPlanModal
          show={showEdit}
          levelID={editLevel}
          onClose={() => setShowEdit(false)}
          onSaved={reloadData}
        /> */}
        <CreateBourseRemiseModal
          show={showCreate}
          onClose={() => setShowCreate(false)}
          onSaved={reloadData}
          currency={paymentSettings?.currency}
        />
        <EditBourseRemiseModal
          show={showEdit}
          onClose={() => setShowEdit(false)}
          onSaved={reloadData}
          record={editDiscount}
          currency={paymentSettings?.currency}
        />
        <FicheDiscountModalApercu
          show={showFicheDiscount}
          onClose={() => setShowFicheDiscount(false)}
          metaData={editDiscount}
        />
        <AnnualRapportDiscountModalApercu
          show={showAnnualRapportDiscount}
          onClose={() => setShowAnnualRapportDiscount(false)}
          reportType={reportType}
        />
      </div>
    </>
  );
};

export default BourseAndRemise;
